import { getLocale } from "app/helpers/session";
import { tr } from "./helpers"

import p from "./en_GB"
import dayjs from "dayjs"

import 'dayjs/locale/sk'
import 'dayjs/locale/cs'
import 'dayjs/locale/pl'
import 'dayjs/locale/en'
import 'dayjs/locale/hu'

let phrases: any = p.messages
let locale = null

if (locale === null) {
    locale = getLocale()
}

if (locale === "sk_SK") {
    phrases = require('./sk_SK').default.messages;
    //import(/* webpackChunkName: "trans_sk-SK" */ "./sk_SK").then(p => { phrases = p.default.messages })
    dayjs.locale('sk')
} else if (locale === "en_GB") {
    dayjs.locale('en')
} else if (locale === "pl_PL") {
    phrases = require('./pl_PL').default.messages;
    //import(/* webpackChunkName: "trans_pl-PL" */ "./pl_PL").then(p => { phrases = p.default.messages })
    dayjs.locale('pl')
} else if (locale === "hu_HU") {
    phrases = require('./hu_HU').default.messages;
    //import(/* webpackChunkName: "trans_hu-HU" */ "./hu_HU").then(p => { phrases = p.default.messages })
    dayjs.locale('hu')
} else {
    phrases = require('./cs_CZ').default.messages;
    //import(/* webpackChunkName: "trans_cs-CZ" */ "./cs_CZ").then(p => { phrases = p.default.messages })
    dayjs.locale('cs')
}

type Messages = any

const transAliases = {
    productName: 'filter_productname',
    OK: 'status_OK',
    NOT_OK: 'status_NOT_OK',
    content_type: 'filter_content_type',
    content_length: 'filter_content_length',
    option_0: 'option_false',
    option_1: 'option_true',
    status_200: 'status_200_0',
    status_403: 'status_403_0',
    status_404: 'status_404_0',
    status_500: 'status_500_0',
    customSet: 'bitmap',
    reflection_angle: 'angle',
    '1_plus_1': '1_plus_1_circle',
    element_e_img_url: 'element_img_url',
    element_e_img_url_input: 'element_img_url_input',
    element_e_alt_img_url: 'element_alt_img_url',
    element_e_alt_img_url_input: 'element_alt_img_url_input',
    element_e_item_id: 'element_item_id',
    element_e_name: 'element_name',
    element_e_url: 'element_url',
    element_e_price_vat: 'element_price_vat',
    element_short_e_img_url: 'element_short_img_url',
    element_short_e_img_url_input: 'element_short_img_url_input',
    element_short_e_alt_img_url: 'element_short_alt_img_url',
    element_short_e_alt_img_url_input: 'element_short_alt_img_url_input',
    element_short_e_item_id: 'element_short_item_id',
    element_short_e_name: 'element_short_name',
    element_short_e_url: 'element_short_url',
    element_short_e_price_vat: 'element_short_price_vat',
    easters_u: 'easter',
    confidence: 'probability',
    max_confidence: 'probability',
    externalImageSource: 'external_image',
    person: 'has_person',
    outpainting_started: 'template_type_4_started',
    outpainting_done: 'template_type_4_done',
    inpainting_started: 'template_type_6_started',
    inpainting_done: 'template_type_6_done',
    remove_background_started: 'template_type_2_started',
    remove_background_done: 'template_type_2_done',
    group_custom: 'custom',
}

export type LangPrefixType = "cz" | "sk" | "pl" | "en" | "hu"
export type LocaleType = 'cs_CZ' | 'en_GB' | 'sk_SK' | 'pl_PL' | 'hu_HU'
export const AllowedLocaleTypes = ['cs_CZ', 'en_GB', 'sk_SK', 'pl_PL', 'hu_HU']

export const transByLocale = (key: string, locale: LocaleType) => {
    if (AllowedLocaleTypes.includes(locale)) {
        const ph = require(`./${locale}`).default.messages;
        return tr(ph, transAliases[key] || key)
    }
    return trans(key)
}

export const trans = (key: keyof Messages, variables: any = null, formatter = null) => {
    const keyOrAliasKey = transAliases[key] || key
    return tr(phrases, keyOrAliasKey, variables, formatter)
}

export const isTrans = (key: keyof Messages) => {
    const keyOrAliasKey = transAliases[key] || key
    return phrases && phrases[keyOrAliasKey] !== undefined
}

export default trans
